const LOADER_ID = "Cookiebot";
const READY_EVENTS = ["CookiebotOnConsentReady", "CookiebotOnAccept", "CookiebotOnDecline"];

const READY_TIMEOUT_MS = 2000;

const loaderPresent = () => Boolean(window.Cookiebot) || Boolean(document.getElementById(LOADER_ID));

export const consentAvailable = () => Boolean(window.Cookiebot?.consent);

export const consentPending = () => loaderPresent() && !consentAvailable();

export const consentGranted = (category) => {
  if (!loaderPresent()) return true;
  if (!consentAvailable()) return false;
  return window.Cookiebot.consent[category] !== false;
};

export const whenConsentGranted = (category, callback) => {
  if (consentGranted(category)) {
    callback();
    return () => {};
  }

  let settled = false;
  let timeoutId = null;

  const unsubscribe = () => {
    settled = true;
    if (timeoutId !== null) {
      window.clearTimeout(timeoutId);
      timeoutId = null;
    }
    READY_EVENTS.forEach((name) => window.removeEventListener(name, onConsentEvent));
  };

  const grant = () => {
    if (settled) return;
    unsubscribe();
    callback();
  };

  function onConsentEvent() {
    if (consentAvailable() && timeoutId !== null) {
      window.clearTimeout(timeoutId);
      timeoutId = null;
    }
    if (consentGranted(category)) grant();
  }

  READY_EVENTS.forEach((name) => window.addEventListener(name, onConsentEvent));

  if (consentPending()) {
    timeoutId = window.setTimeout(() => {
      timeoutId = null;
      if (!consentAvailable()) grant();
    }, READY_TIMEOUT_MS);
  }

  return unsubscribe;
};
